'use client';

import { Route } from 'next';
import { useSearchParams } from 'next/navigation';
import { buildUrlWithReturnTo, withEmailParam } from '@/utils/redirect-validation';

export function useUrlWithReturnTo() {
  const searchParams = useSearchParams();

  const buildUrlWithReturnToParam = (basePath: string): Route => {
    const returnTo = searchParams.get('returnTo');
    const email = searchParams.get('email');
    return withEmailParam(buildUrlWithReturnTo(basePath, returnTo), email);
  };

  return {
    buildUrlWithReturnToParam,
  };
}
